import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
// import * as $ from 'jquery';
import $ from 'jquery';

import { FreeFormAgendaService } from './free-form-agenda.service';
import { C } from '@angular/cdk/keycodes';
import { AgoraConfigService } from 'src/AgoraConfigService';
declare var CKEDITOR: any;
var taskMinuteId: string;
@Injectable({
	providedIn: 'root'
})
export class ImageUploadService {
	agoraConfigObject: any;
	constructor(private http: HttpClient, private commonAgService: FreeFormAgendaService, private agoraConfig: AgoraConfigService) {
		this.agoraConfigObject = this.agoraConfig.getConfig().endpoints;

	}
	/* Common method to bind image upload to ckeditor */
	fnImageUpload(obj: any, editor: any, evt: any) {
		editor.on("contentDom", function () {

			editor.document.on("DOMNodeRemoved", function (e: { target: any; }) {
				if ($(e.target).hasClass("minImageTag")) {
					$(".uploadImgIcon" + $(e.target).attr("imageid")).remove();
				}
			});

		});
		var fileLoader = evt.data.fileLoader,
			formData = new FormData(),
			xhr = fileLoader.xhr;
		xhr.open('POST', `${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.attachment}imageUpload`, true);
		xhr.setRequestHeader("Authorization", "Bearer " + localStorage.getItem("token"));
		xhr.setRequestHeader("userName", localStorage.getItem("encLoginName"));
		var file = fileLoader.file;
		var fileType = file["type"];
		var validImageTypes = ["image/gif", "image/jpeg", "image/png"];
		var fileSize = Math.round((fileLoader.file.size) / (1024));

		if (fileSize >= 2048) { // make it in MB so divide by 1024*1024

			evt.cancel();
			$(".cke_widget_element").remove();
			$(".cke_widget_uploadimage").remove();
			evt.stop();
			return false;
		}
		if ($.inArray(fileType, validImageTypes) < 0) {

			evt.cancel();
			$(".cke_widget_element").remove();
			$(".cke_widget_uploadimage").remove();
			evt.stop();
			return false;
		}
		formData.append('fileUpload', fileLoader.file, fileLoader.fileName);

		// formData.append("uploadEditorId",editor.name);
		var currentMinId = obj.getAttribute("minid");
		var curAgendaId = obj.getAttribute("agid");
		var meetingId = this.commonAgService.meetingResponse.meetingId;

		var attachmentJson = {
			// "uploadEditorId": editor.name,
			'fkEntityId': curAgendaId,
			'fkMeetingId': meetingId,
			'orgCode': localStorage.orgCode
			// 'minutesId': currentMinId
		}
		formData.append('attachment', JSON.stringify(attachmentJson));

		fileLoader.xhr.send(formData);
		// Prevented the default behavior.
		evt.stop();

		return true;
	}
	fnImgUploadResponse(obj: any, editor: any, evt: any) {
		var fileLoader = evt.data.fileLoader,
			xhr = fileLoader.xhr,
			data = evt.data;
		data.error = null;
		var response = JSON.parse(xhr.responseText);
		var fileName = "";
		if (response != null && response != undefined && response.attachmentId != null && response.attachmentId != undefined && response.attachmentId != "undefined" && response.attachmentId != "null" && response.attachmentId != '') {
			this.insertImageIntoNote(response, editor);
			evt.stop();
			//$(".cke_dialog_close_button span").trigger("click");  
			return false;
		}
		evt.stop();
		return true;
	}
	//to append image into textarea for modern and classic for both iframe and drag and drop
	insertImageIntoNote(response: any, editor: any) {

		var pageIns = this;
		var fileName = response.fileName;
		var imgUrl = response.attachmentId;
		var heightOfImg = "auto";
		var widthOfImg = "auto";
		var src = `${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.attachment}imageDownload/` + imgUrl;
		if (imgUrl != "") {
			var image = new Image();
			image.src = src;
			image.onload = function () {
				var height = 500;
				var width = 500;

				width = image.naturalWidth;
				height = image.naturalHeight;
				if (width >= 700) {
					widthOfImg = "670px";
				} else {
					widthOfImg = "" + width + "px";
				}
				pageIns.insertImg(editor, imgUrl, fileName, widthOfImg, heightOfImg, src);
			}
		}

	}

	insertImg(editor: any, imgUrl: any, fileName: any, widthOfImg: any, heightOfImg: any, src: any) {


		//
		if (src == 'undefined') {
			window.alert("No image URL is updated")
		}

		var spanElem = new CKEDITOR.dom.element.createFromHtml("<span class='min_img_comn_cls uploadImageIcons uploadImgIcon" + imgUrl + "' style='display:none;' imageId='" + imgUrl + "' data-toggle='tooltip' data-html='true' fileName='" + fileName + "' imgsrc='" + src + "' data-original-title='" + fileName + "' ><i class='mdi mdi-image-filter'> </i></span>");
		var imgElem = new CKEDITOR.dom.element.createFromHtml("<img id='minImageInsId" + imgUrl + "' class='imageAlign min_img_comn_cls minImageTag minutesImageAtt" + imgUrl + "' imageId='" + imgUrl + "' width='" + widthOfImg + "' height='" + heightOfImg + "' fileName='" + fileName + "' alt='Image Unavailable'  src='" + src + "' data-cke-saved-src='" + src + "'></img>");
		editor.insertElement(imgElem);
		editor.insertElement(spanElem);//plz,don't change the order.or else shortcut will replace the image also
	}

	//function to show image as a lootip for classic page
	imgOnTooltip(actualElem: any) {
		var elem = null;
		if (actualElem != undefined && actualElem != null && actualElem != "") {
			elem = actualElem.find(".uploadImageIcons");
		} else {
			elem = $(".uploadImageIcons");
		}
		elem.each(function () {
			var imgSrc = $(actualElem).attr("imgsrc");
			if (imgSrc != "") {
				$(actualElem).attr("data-original-title", "");
				$(actualElem).attr("data-original-title", '<img class="imgToolTipCls" width="50" height="50" src="' + imgSrc + '">');
			}
		});
		elem.tooltip();
	}
}
